import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import TextField from 'src/components/TextField';
import { useTranslation } from 'react-i18next';
import s from './ColumnFilters.styles';

const ColumnFiltersMorePopup = ({ columns, onSubmit, onClose }) => {
  const ref = useRef(null);
  const { t } = useTranslation();

  const [search, setSearch] = useState('');

  useEffect(() => {
    const handleClickOutside = e => {
      if (ref.current && !ref.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);

  return (
    <s.MorePopup ref={ref}>
      <s.MoreSearch>
        <TextField
          onChange={e => setSearch(e.target.value)}
          placeholder={t('SEARCH_COLUMN')}
          value={search}
        />
        <s.MoreSearchIcon name="search" />
      </s.MoreSearch>
      <s.MoreContent>
        {columns.map((column, index) => {
          if (
            search &&
            column.label.toLowerCase().indexOf(search.toLowerCase()) === -1
          ) {
            return null;
          }

          return (
            <s.MoreContentItem key={index} onClick={() => onSubmit(column)}>
              {column.label}
            </s.MoreContentItem>
          );
        })}
      </s.MoreContent>
    </s.MorePopup>
  );
};

ColumnFiltersMorePopup.propTypes = {
  columns: PropTypes.array,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default React.memo(ColumnFiltersMorePopup);
